import * as React from 'react';
import ContractPdf from './contract/ContractPdf';
import Typography from '../../layouts/theme-onboarding/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import AddCardIcon from '@mui/icons-material/AddCard';
import Color from '../../layouts/Color';

const info = { textAlign: 'left' };
const container = { mt: 1 };
const iconColor = { color: Color.Main};

export default function SignContract(props) {
  return (
    <React.Fragment>
      <Stack direction="row" justifyContent="center" spacing={1}>
        <Typography variant="h6" marked="left" gutterBottom color={Color.Main}>Sign Contract</Typography>
        <AddCardIcon sx={iconColor}></AddCardIcon>
      </Stack>
      <Grid container spacing={3} sx={container}>
        <Grid item xs={12} sx={info}> 
          <Typography variant="subtitle1" color={Color.Main}> Below is the terms of contract between customer and Apollo: </Typography> 
        </Grid>
        <ContractPdf onUpdateStep5Data={props.onUpdateStep5Data} step4Response={props.step4Response} contractPresignedUrl={props.contractPresignedUrl} contractS3Key={props.contractS3Key} ></ContractPdf>
      </Grid>
    </React.Fragment>
  );
}